// S9 App settings, one section per URL (M11). Editors and Admins edit (the AppView's `can`; poc
// CT-008); the retired "Roles and groups", "AI reports" and "Who sees the widget" (CT-026) sections are gone, so
// their URLs are not found.
import { createFileRoute, notFound } from '@tanstack/react-router';
import { AppSettingsPage, isSettingsSection } from '@/features/admin/apps/AppSettingsPage';
import { requireStaffSession } from '@/lib/session';

interface SettingsSearch {
  /** Set by the S8 wizard: show "Your app is registered". */
  registered?: boolean;
}

export const Route = createFileRoute('/apps/$appId/settings/$section')({
  validateSearch: (search: Record<string, unknown>): SettingsSearch =>
    search.registered === true || search.registered === 'true' ? { registered: true } : {},
  beforeLoad: async ({ context, location, params }) => {
    await requireStaffSession(context.queryClient, location.href);
    if (!isSettingsSection(params.section)) {
      throw notFound();
    }
  },
  component: SettingsSectionPage,
});

function SettingsSectionPage() {
  const { appId, section } = Route.useParams();
  const { registered } = Route.useSearch();
  if (!isSettingsSection(section)) {
    return null;
  }
  return <AppSettingsPage appId={appId} section={section} registered={registered === true} />;
}
